// src/config/menuBase.js
export const baseMenus = {
  top: [
    {
      title: "Blogs",
      icon: "IoNewspaperOutline",
      key: "blog",
      public: true,
      children: [
        { label: "public blog", path: "/blogs", icon: "IoNewspaperOutline" },
        { label: "manage posts", path: "/dash/blogs", icon: "IoNewspaperOutline" },
        { label: "Add New Post", path: "/dash/blogs/new", icon: "IoNewspaperOutline" },
      ],
    },
  ],
  bottom: [
    {
      title: "Pajak Automation",
      icon: "FaIndustry",
      key: "pajakAutomation",
      app: "PAJAK_AUTOMATION",
      children: [
        { label: "Wajib Pajak (Tax Payers)", path: "/dash/taxpayers", icon: "BsClipboardCheck", allowedRoles: ["TENANT_ADMIN"] },
        { label: "Ringkasan Pajak", path: "/dash/tax", icon: "BsClipboardCheck" },
        { label: "Bukti Potong", path: "/dash/withholding_docs", icon: "BsClipboardCheck" },
        { label: "Customers", path: "/dash/customers", icon: "BsClipboardCheck", allowedRoles: ["TENANT_ADMIN"] },
        { label: "file_list", path: "/dash/file_list", icon: "BsClipboardCheck" },
      ],
    },
    {
      title: "POS Application",
      icon: "FaIndustry",
      key: "posApplication",
      app: "POS_APPLICATION",
      children: [
        { label: "Orders", path: "/dash/orders", icon: "BsClipboardCheck" },
        { label: "Foods", path: "/dash/foods", icon: "BsClipboardCheck", allowedRoles: ["TENANT_ADMIN"] },
        { label: "Drinks", path: "/dash/drinks", icon: "BsClipboardCheck", allowedRoles: ["TENANT_ADMIN"] },
      ],
    },
    {
      title: "easyNewsroom",
      icon: "FaIndustry",
      key: "easyNewsroom",
      app: "EASY_NEWSROOM",
      children: [
        { label: "Notes", path: "/dash/notes", icon: "BsClipboardCheck" },
        { label: "Campaigns", path: "/dash/campaigns", icon: "BsClipboardCheck" },
        { label: "Business Details", path: "/dash/businessdetails", icon: "BsClipboardCheck" },
        { label: "OpenAI Integration", path: "/dash/openai", icon: "BsClipboardCheck" },
      ],
    },
    {
      title: "Property Assistant",
      icon: "FaIndustry",
      key: "propertyAssistant",
      app: "PROPERTY_ASSISTANT",
      children: [
        { label: "Properties List", path: "/dash/notes", icon: "BsClipboardCheck" },
        { label: "Legal", path: "/dash/campaigns", icon: "BsClipboardCheck" },
        { label: "Brighton Products", path: "/dash/businessdetails", icon: "BsClipboardCheck" },
      ],
    },
    {
      title: "Document Evaluator",
      icon: "FaIndustry",
      key: "documentEvaluator",
      app: "DOCUMENT_EVALUATOR",
      children: [
        { label: "Notes", path: "/dash/notes", icon: "BsClipboardCheck" },
        { label: "Campaigns", path: "/dash/campaigns", icon: "BsClipboardCheck" },
        { label: "Business Details", path: "/dash/businessdetails", icon: "BsClipboardCheck" },
        { label: "OpenAI Integration", path: "/dash/openai", icon: "BsClipboardCheck" },
      ],
    },
    {
      title: "MongoDB Application",
      icon: "FaIndustry",
      key: "mongodbApplication",
      app: "MONGODB_APPLICATION",
      children: [
        { label: "Notes", path: "/dash/notes", icon: "BsClipboardCheck" },
        { label: "Campaigns", path: "/dash/campaigns", icon: "BsClipboardCheck" },
        { label: "Business Details", path: "/dash/businessdetails", icon: "BsClipboardCheck" },
        { label: "OpenAI Integration", path: "/dash/openai", icon: "BsClipboardCheck" },
      ],
    },
    {
      title: "MySQL Application",
      icon: "FaIndustry",
      key: "mysqlApplication",
      app: "MYSQL_APPLICATION",
      children: [
        { label: "Chitose sales", path: "/dash/sales", icon: "BsClipboardCheck" },
        { label: "Chitose summary", path: "/dash/sales/distinct", icon: "BsClipboardCheck" },
      ],
    },
    {
      title: "MQTT Application",
      icon: "FaIndustry",
      key: "mqttApplication",
      app: "MQTT_APPLICATION",
      children: [
        { label: "FishFlow", path: "/dash/fishFlow", icon: "BsClipboardCheck" },
      ],
    },
    {
      title: "Settings",
      icon: "FiSettings",
      key: "settings",
      adminOnly: true,
      children: [
        { label: "System", path: "/dash/system", icon: "FiSettings" },
        { label: "Users", path: "/dash/users", icon: "FaUsersCog" },
      ],
    },
    {
      title: "Supports",
      icon: "FaIndustry",
      key: "supports",
      public: true,
      children: [
        { label: "Help", path: "/dash/helpsupport", icon: "FiSettings" },
      ],
    },
  ],
};